import { AppState } from 'types/app';
import { BadgeMetadata } from 'types/badges';

export const selectBadgeMetadata = (state: AppState, id: string) => state.badges?.metadata.find((badge: BadgeMetadata) => badge.id === id);
